import styled from "styled-components";

const ErrorStyled = styled.div`
    display: flex;
    span {
        font-size: 1.4rem;
    }
    p {
        color: ${props => props.theme.black};
        font-size: 1.4rem;
        line-height: 2.3rem;
    }
    button,
    a {
        font-family: ${props => props.theme.fontBold};
        font-size: 1.4rem;
        color: ${props => props.theme.lightGreen};
        text-decoration: underline;
    }
    svg {
        display: none;
        margin-right: 2rem; 
        @media only screen and (min-width: ${props => props.theme.tablet}) {
            display: block;
        }
    }
`;

const ErrorStyledContainer = styled.div`
    margin-bottom: 2rem;
    @media only screen and (min-width: ${props => props.theme.tablet}) {
        margin-bottom: 2rem;
    }
    background: ${props => props.theme.lightYellow};
    border: 2px solid ${props => props.theme.gold};
    border-radius: 0.5rem;
    display: flex;
    width: 100%;
    align-items: center;
    padding: 2.5rem;
`;

const ErrorWarningText = styled.p`
    margin-bottom: 0;
    font-family: ${props => props.theme.fontBold};
`;

export { ErrorStyled, ErrorStyledContainer, ErrorWarningText };
